module.exports = __webpack_public_path__ + "e9c801ceaaa8055344613dd18c0fbbe7.png";